import styles from "./SessionToReschedulePill.module.scss";

import { Trans } from "react-i18next";

import { useBookingContext } from "@/modules/coaching/booking/context/BookingContext";
import { formatSessionDateTimeWithTimezone } from "@/modules/coaching/reschedule-sessions/utils/formatSessionDateTimeWithTimezone";
import { getTimezoneAbbreviation } from "@/modules/coaching/reschedule-sessions/utils/getTimezoneAbbreviation";

export const SessionToReschedulePill = () => {
  const { coachName, originalSessionStart, timezone } = useBookingContext();

  if (!originalSessionStart || !timezone) {
    return null;
  }

  const sessionDateTime = formatSessionDateTimeWithTimezone(
    originalSessionStart,
    timezone.value,
    getTimezoneAbbreviation(timezone.label),
  );

  return (
    <div className={styles.sessionPill}>
      <Trans
        i18nKey="rescheduleSession.sessionDetails"
        components={{
          prefix: <span className={styles.sessionLabel} />,
          details: <span />,
        }}
        values={{ coachName, sessionDateTime }}
      />
    </div>
  );
};
